export const onlyTruthy = <TValue>(
  value: TValue | null | undefined
): value is TValue => !!value;
